module.exports = __webpack_public_path__ + "media/images/flags/ca-b7f8c217c4071faac16642b21f8d5ecd.svg";